import { SortingState } from "@tanstack/react-table";
import { useState } from "react";

export default () => {
	const [sorting, setSorting] = useState<SortingState>([]);

	return { sorting, setSorting };
};
